import React from "react";
import {SelectInput} from "asocomponents"

function SelectFactura({ onChange, width, valor }) {
  const data = [{ idTipoFactura: 2, descripcion: "Factura B" }, { idTipoFactura: 3, descripcion: "Factura C" }]
  return (
    <div>
      <SelectInput 
        options={data} 
        placeholder="Tipo Comprobante" 
        todos={false} 
        onChange={onChange} 
        defaultValue={valor || "-2"} 
        width={width}
        valueField="idTipoFactura"
        >
      </SelectInput>
    </div>
  )
}

export default SelectFactura